import { createSvgIcon } from '@mui/material/utils';
export default createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.5 13.5">
        <g id="c">
            <rect
                stroke="currentColor"
                fill="none"
                x="4"
                y="4"
                width="9"
                height="9"
            />
            <polygon
                className="e"
                points="4 4 9 4 9 0 0 0 0 9 4 9 4 4"
                fill="currentColor"
            />
        </g>
    </svg>,
    'React'
);
